import _classCallCheck from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { warn } from '../util/console.js';
import { isBrowser } from '../features.js';
import { IDX_RESPONSE_STORAGE_NAME } from '../constants.js';
import 'tiny-emitter';
import 'js-cookie';
import AuthSdkError from '../errors/AuthSdkError.js';
import { SavedObject } from '../storage/SavedObject.js';
import { createCoreStorageManager } from '../core/storage.js';
function createIdxStorageManager() {
  var CoreStorageManager = createCoreStorageManager();
  return /*#__PURE__*/function (_CoreStorageManager) {
    function IdxStorageManager(storageManagerOptions, cookieOptions, storageUtil) {
      _classCallCheck(this, IdxStorageManager);
      return _callSuper(this, IdxStorageManager, [storageManagerOptions, cookieOptions, storageUtil]);
    }
    _inherits(IdxStorageManager, _CoreStorageManager);
    return _createClass(IdxStorageManager, [{
      key: "getIdxResponseStorage",
      value: function getIdxResponseStorage(options) {
        var storage;
        if (isBrowser()) {
          try {
            storage = this.storageUtil.getStorageByType('memory', options);
          } catch (e) {
            warn('No response storage found, you may want to provide custom implementation for intermediate idx responses to optimize the network traffic');
          }
        } else {
          var transactionStorage = this.getTransactionStorage(options);
          if (transactionStorage) {
            storage = {
              getItem: function getItem(key) {
                var transaction = transactionStorage.getStorage();
                if (transaction && transaction[key]) {
                  return transaction[key];
                }
                return null;
              },
              setItem: function setItem(key, val) {
                var transaction = transactionStorage.getStorage();
                if (!transaction) {
                  throw new AuthSdkError('Transaction has been cleared, failed to save idxState');
                }
                transaction[key] = val;
                transactionStorage.setStorage(transaction);
              },
              removeItem: function removeItem(key) {
                var transaction = transactionStorage.getStorage();
                if (!transaction) {
                  return;
                }
                delete transaction[key];
                transactionStorage.setStorage(transaction);
              }
            };
          }
        }
        if (!storage) {
          return null;
        }
        return new SavedObject(storage, IDX_RESPONSE_STORAGE_NAME);
      }
    }]);
  }(CoreStorageManager);
}
export { createIdxStorageManager };